import { Breadcrumbs, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import ProgramLink from "./ProgramLink";
import GroupLink from "./GroupLink";

const GroupDevice = ({ programId, groupId, programsList }) => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb">
        <ProgramLink />
        <GroupLink programId={programId} label={programsList[programId]} />
        <Typography color="textPrimary">{programsList[groupId]}</Typography>
      </Breadcrumbs>
      <Typography variant="h3" color="secondary" style={{ marginTop: 18 }}>
        {t("navigation.devices")}
      </Typography>
    </>
  );
};

export default GroupDevice;